var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Investor Analysis")]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-content-left" }, [
      _c("ul", [
        _c(
          "li",
          {
            class: _vm.show_list ? "active" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showList()
              },
            },
          },
          [
            _c("h3", [_vm._v("Investor List")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "shows which investors might be interested in your offering"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: _vm.show_map ? "active" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showMap()
              },
            },
          },
          [
            _c("h3", [_vm._v("Investor World Map")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "shows where potential investors for your offering are located"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: _vm.show_chart ? "active" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showChart()
              },
            },
          },
          [
            _c("h3", [_vm._v("Investor Pie Chart")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "shows which type of investors might be interested in your offering"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: _vm.show_treemap ? "active" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showTreeMap()
              },
            },
          },
          [
            _c("h3", [_vm._v("Investor Treemap")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "visualises which type of investors might be interested in your offering"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: _vm.show_barchart ? "active" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showBarChart()
              },
            },
          },
          [
            _c("h3", [_vm._v("Investor Clustered Bar Chart")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "shows how many investors might be interested in your offering"
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "pta-button", attrs: { href: "/account/calendar" } },
        [_vm._v("PROCEED TO BOOK A CALL WITH US")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "pta-content-right",
        style: _vm.show_map ? "max-width:1480px;" : "",
      },
      [
        _vm.show_map
          ? _c("div", [
              _c("h2", { staticStyle: { "margin-bottom": "0px" } }, [
                _vm._v("World Map"),
              ]),
              _vm._v(" "),
              !_vm.is_premium && _vm.email_status < 1
                ? _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.\n      "
                    ),
                  ])
                : _c("div", [
                    _vm.is_loading
                      ? _c(
                          "div",
                          {
                            staticClass: "pta-loading",
                            staticStyle: { "margin-top": "30px" },
                          },
                          [_vm._v("Data is loading ...")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      staticStyle: {
                        border: "0",
                        width: "100%",
                        height: "710px",
                        background: "transparent",
                      },
                      attrs: { id: "map_url_frame", src: _vm.map_url },
                      on: {
                        load: function ($event) {
                          _vm.is_loading = false
                        },
                      },
                    }),
                  ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_chart
          ? _c("div", [
              _c("h2", { staticStyle: { "margin-bottom": "50px" } }, [
                _vm._v("Pie Chart"),
              ]),
              _vm._v(" "),
              (!_vm.is_premium || !_vm.investors.length) && _vm.email_status < 2
                ? _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.\n      "
                    ),
                  ])
                : _c("div", [
                    _vm.is_loading
                      ? _c(
                          "div",
                          {
                            staticClass: "pta-loading",
                            staticStyle: { "margin-top": "30px" },
                          },
                          [_vm._v("Data is loading ...")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      staticStyle: {
                        border: "0",
                        width: "100%",
                        height: "710px",
                        background: "transparent",
                      },
                      attrs: {
                        id: "piechart_url_frame",
                        src: _vm.piechart_url,
                      },
                      on: {
                        load: function ($event) {
                          _vm.is_loading = false
                        },
                      },
                    }),
                  ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_treemap
          ? _c("div", [
              _c("h2", { staticStyle: { "margin-bottom": "0px" } }, [
                _vm._v("Treemap"),
              ]),
              _vm._v(" "),
              (!_vm.is_premium || !_vm.investors.length) && _vm.email_status < 3
                ? _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.\n      "
                    ),
                  ])
                : _c("div", [
                    _vm.is_loading
                      ? _c(
                          "div",
                          {
                            staticClass: "pta-loading",
                            staticStyle: { "margin-top": "30px" },
                          },
                          [_vm._v("Data is loading ...")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      staticStyle: {
                        border: "0",
                        width: "100%",
                        height: "710px",
                        background: "transparent",
                      },
                      attrs: { id: "treemap_url_frame", src: _vm.treemap_url },
                      on: {
                        load: function ($event) {
                          _vm.is_loading = false
                        },
                      },
                    }),
                  ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_barchart
          ? _c("div", [
              _c("h2", { staticStyle: { "margin-bottom": "0px" } }, [
                _vm._v("Bar Chart"),
              ]),
              _vm._v(" "),
              (!_vm.is_premium || !_vm.investors.length) && _vm.email_status < 4
                ? _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.\n      "
                    ),
                  ])
                : _c("div", [
                    _vm.is_loading
                      ? _c(
                          "div",
                          {
                            staticClass: "pta-loading",
                            staticStyle: { "margin-top": "30px" },
                          },
                          [_vm._v("Data is loading ...")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      staticStyle: {
                        border: "0",
                        width: "100%",
                        height: "710px",
                        background: "transparent",
                      },
                      attrs: {
                        id: "barchart_url_frame",
                        src: _vm.barchart_url,
                      },
                      on: {
                        load: function ($event) {
                          _vm.is_loading = false
                        },
                      },
                    }),
                  ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_list
          ? _c("div", { staticClass: "pta-investor-selection" }, [
              _c("h2", { staticStyle: { "margin-bottom": "50px" } }, [
                _vm._v("Investor List"),
              ]),
              _vm._v(" "),
              !_vm.investors.length
                ? _c("div", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(
                      "\n        Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.\n      "
                    ),
                  ])
                : _c("div", [
                    _c(
                      "table",
                      { attrs: { cellpadding: "0", cellspacing: "0" } },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        !_vm.investors
                          ? _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "6", align: "center" } },
                                [
                                  _vm._v(
                                    "\n              Data is loading ...\n            "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.investors, function (investor) {
                          return _vm.investors && investor.name
                            ? _c("tr", [
                                _c("td"),
                                _vm._v(" "),
                                !_vm.is_premium
                                  ? _c("td", { attrs: { valign: "top" } }, [
                                      _vm._v("******"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.is_premium
                                  ? _c("td", { attrs: { valign: "top" } }, [
                                      _vm._v(_vm._s(investor.name)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { attrs: { valign: "top" } },
                                  _vm._l(
                                    investor.investor_types,
                                    function (investor_type) {
                                      return _c("span", [
                                        _vm._v(_vm._s(investor_type)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { attrs: { valign: "top" } },
                                  _vm._l(
                                    investor.asset_classes,
                                    function (asset_class) {
                                      return _c("span", [
                                        _vm._v(_vm._s(asset_class)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { attrs: { valign: "top" } },
                                  _vm._l(investor.geos, function (geo) {
                                    return _c("span", [_vm._v(_vm._s(geo))])
                                  }),
                                  0
                                ),
                              ])
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ]),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pta-clear" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th"),
      _vm._v(" "),
      _c("th", [_vm._v("Organisation")]),
      _vm._v(" "),
      _c("th", [_vm._v("Investor Type")]),
      _vm._v(" "),
      _c("th", [_vm._v("Preferred Asset Class")]),
      _vm._v(" "),
      _c("th", [_vm._v("Preferred Geographic Area")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }